<template>
    <div v-if="details.indentStatus === 8" > <!-- Hard-coded because statusUtil not available -->
      <portal target-el="#filter">
        <Breadcrumb
          :isHistoryBack="true"
          :hideBackBtn="true"
          :message="details.order"
          :status="details.status"
          :indentStatus="details.indentStatus"
        >
        </Breadcrumb>
      </portal>
      <div class="status-msg">
        <span>
          <svgicon name="shipment-cancel" width="300" height="300" :original="true" />
          <p>Your order has been cancelled. Please contact support for further updates.</p>
        </span>
      </div>
    </div>
    <div v-else class="order-wrapper primary-disabled" >
      <portal target-el="#filter">
        <Breadcrumb
          :isHistoryBack="true"
          :hideBackBtn="true"
          :message="trackDetail.shipmentNumber"
          :status="details.status"
          :indentStatus="details.indentStatus"
        >
        </Breadcrumb>
      </portal>
      <div v-if="!details.error">
        <div class="loading-app" v-if="isLoading">
          <Spinner />
        </div>
        <Row :gutter="20" class="row-reverse" v-else>
          <Col :xl="6" :lg="6" :md="8">
           <div class="slider-collapse wbview">
            <div class="drawer-header slider-collapse-header" @click="active = !active">
              <span class="status status-icon status-grey">
                {{status.name}}
                <span class="badge" v-if="trackingType && trackingType.iconName">
                  <svgicon :name="trackingType.iconName" width="8" height="8" />
                </span>
              </span>
              <span class="icon-mv">
                  <svgicon name="icon-add-dark"  v-if="active" width="16" height="16" :original="true"/>
                  <svgicon name="icon-minus-dark" v-else width="16" height="16" :original="true"/>
              </span>
            </div>
            <div class="drawer-body slider-collapse-body" :class="{ showview: active }">
              <ul class="drawer-list">
                <li v-for="header in trackDetailsConstant" :key="header.id">
                  <span v-if="trackDetail[header.column]">
                    <label>{{header.title}}</label>
                    <div class="list-content">
                      {{trackDetail[header.column]}}
                      <small
                        v-if="header.subDetail && trackDetail[header.subDetail.column]"
                        :class="header.subDetail.class"
                      >
                      {{trackDetail[header.subDetail.column]}}
                      </small>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
           </div>
          </Col>
           <Col :xl="18" :lg="18" :md="16">
            <ElTabs class="tab-default">
              <!--Tab1: Timeline Tab -->
              <Tab-pane label="Timeline">
                <div class="tab-content content-scroll-sm">
                  <div class="map-tracking">
                    <div class="status-msg" v-if="showMapView">
                      <Spinner v-if="isLoading"/>
                      <span v-else-if="!details || !this.details.pings || !this.details.pings.length">
                        <svgicon name="empty-location" width="251" height="160" :original="true" />
                        <p>No Pings Found</p>
                      </span>
                      <iframe v-else-if="!isLoading" :src="trackUrl" frameborder="0" style="border:0"
                        width="100%" height="450"/>
                    </div>
                    <Row v-else-if="timelineEvent.length > 0">
                      <Col :span="13">
                        <!-- Loop courier tracking response  -->
                        <Timeline class="timeline-default mt-10 timeline-with-action">
                          <TimelineItem v-for="(event, idx) in timelineEvent" :key="idx+event.time" placement="top" class="dot-purple mb-5">
                            <div class="el-timeline-item__timestamp is-top">
                              <span class="date">{{ formatDate(event.time) }}</span>
                              <span>{{ formatTime(event.time) }}</span>
                            </div>
                            <h4>{{ event.type }}</h4>
                            <p v-if="event.name">{{ event.name }}</p>
                            <p v-if="event.reason && event.reason !== ''">Reason: {{ event.reason }}</p>
                            <p v-if="event.pincode">{{ event.pincode }}</p>
                            <p v-if="event.remarks">{{ event.remarks }}</p>
                          </TimelineItem>
                        </Timeline>
                      </Col>
                    </Row>
                    <div v-else class="status-msg">No Data Found</div>
                  </div>
                  <Table v-if="showMapView" :data="stopsData" :stripe="true" class="table-striped bordered mt-20" aria-describedby="consigneeTripDetailsData">
                    <table-column
                      v-for="column in pickDropOffConstants"
                      :label="column.title"
                      :width="column.width"
                      :key="column.id">
                      <template slot-scope="scope">
                        <span v-if="scope.row[column.label]">{{scope.row[column.label]}}</span>
                        <span v-else>-</span>
                      </template>
                    </table-column>
                  </Table>
                </div>
              </Tab-pane>
              <!-- Tab2: Materials Tab -->
              <Tab-pane label="Materials">
                <div class="tab-content content-scroll-sm">
                  <Table v-if="materialData.length > 0" :data="materialData" :stripe="true" class="table-striped bordered mt-20" aria-describedby="cosigneeTripDetailsMatrialData">
                    <table-column
                      v-for="column in materialConstants"
                      :label="column.title"
                      :width="column.width"
                      :key="column.id">
                      <template slot-scope="scope">
                        <span v-if="scope.row[column.label]">{{scope.row[column.label]}}</span>
                        <span v-else>-</span>
                      </template>
                    </table-column>
                  </Table>
                  <span class="status-msg" v-else>
                    No Materials Found
                  </span>
                </div>
              </Tab-pane>
            </ElTabs>
          </Col>
        </Row>
      </div>
      <div v-else class="status-msg">
        <span>
          <svgicon name="empty-timeline" width="249" height="176" :original="true" />
          <p>No Data Found</p>
        </span>
      </div>
    </div>
  </template>

<script>
import {
  mapGetters,
} from 'vuex';
import {
  pickDropOffConstants,
  trackDetailsConstant,
  trackStatus,
  trackType,
  materialConstants,
} from '@/constants/trackConstants';
import { getAddress, getLocation, getDistanceRem } from '@common/lib/track';
import {
  formatLastKnownTime,
  getDateDiffInDaysMins,
  formatDetailedTime,
} from '@/lib/Date';
import moment from 'moment';
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      trackStatus,
      trackType,
      pickDropOffConstants,
      trackDetailsConstant,
      materialConstants,
      courierTimeline: [],
      details: {},
      active: false,
    };
  },
  async mounted() {
    this.$store.commit('track/initialReset');
    const orderNo = this.$route.params.orderNo;
    const consigneeId = this.$route.query.id;
    const bookingId = this.$route.query.bookingId;
    this.details = await this.$store.dispatch('track/getConsigneeTripDetails', { orderNo, consigneeId, bookingId });
    if (this.details && this.details.error) {
      this.$errorMessage({ message: this.details.error });
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'track/isLoading',
      configurations: 'app/configurations',
      environmentVariables: 'app/environmentVariables',
    }),
    showMapView() {
      return this.details.is_map_view;
    },
    timeFormat() {
      return this.configurations &&
        this.configurations.is_datepicker_24H_enabled
        ? 'HH:mm'
        : 'hh:mm A';
    },
    timelineEvent() {
      return this.details.courier_timeline || [];
    },
    materialData() {
      return this.details.materials ? this.details.materials.map((material) => {
        let quantity = '';
        if (material.quantity.cases) {
          quantity += `${material.quantity.cases} cases `;
        }
        if (material.quantity.pieces) {
          quantity += `${material.quantity.pieces} pieces`;
        }
        return {
          quantity,
          volume: `${material.volume.value} ${material.volume.unit}`,
          weight: `${material.weight.value} ${material.weight.unit}`,
          code: material.code,
          reference_id: material.reference_id,
        };
      }) : [];
    },
    trackUrl() {
      const tripDetails = {
        locations: this.getLocations(this.details.pings || []),
        destination: this.getLocations(this.details.dropLatLongs || [], this.details.allDropLocations, 'destination'),
        source: this.getLocations(this.details.pickupLatLongs || [], this.details.allPickupLocations, 'source'),
        haltThreshold: (this.configurations && this.configurations.track_settings
            && this.configurations.track_settings.halt_threshold) || 2,
        mapSettings: this.environmentVariables && this.environmentVariables.map_settings,
      };

      this.$session.set('mapData', tripDetails);
      return `${window.location.origin}/track/map`;
    },
    windowHeight() {
      return `${window.innerHeight - 210}px`;
    },
    status() {
      return this.trackStatus.find(val => val.value === this.details.status);
    },
    trackingType() {
      return this.trackType.find(val => val.value === this.details.typeOfTracking);
    },
    stopsData() {
      const stopsArray = [];
      if (this.details && this.details.pickupLocations && !(this.configurations && this.configurations.track_settings
          && this.configurations.track_settings.hide_pickup_from_track)) {
        this.details.pickupLocations.forEach((val) => {
          const obj = {
            stopType: 'Pickup',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      if (this.details && this.details.dropLocations) {
        this.details.dropLocations.forEach((val) => {
          const obj = {
            stopType: 'Drop Off',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      return stopsArray;
    },
    trackDetail() {
      const obj = {
        shipmentNumber: this.details.shipmentNumber,
        transporterName: this.details.transporterName,
        eta: formatDetailedTime(this.details.plannedEta),
        createdAt: formatDetailedTime(this.details.createdAt),
        driverNumber: this.details.driverPhoneNumber || '-',
        driverName: this.details.driverName || '-',
        status: this.status,
        truckNumber: this.details.truck_number || '-',
        isGpsEnabled: (this.details.typeOfTracking === 'GPS') ? 'GPS ENABLED' : '',
      };
      const firstPickAddress = this.details.pickupLocations && this.details.pickupLocations[0]
       && this.details.pickupLocations[0].address;
      const lastDropAddress = this.details.dropLocations && this.details.dropLocations[this.details.dropLocations.length - 1]
       && this.details.dropLocations[this.details.dropLocations.length - 1].address;
      if (firstPickAddress) {
        obj.source = firstPickAddress.name;
        obj.sourceAddress = getAddress(firstPickAddress);
      }
      if (lastDropAddress) {
        obj.destination = lastDropAddress.name;
        obj.destinationAddress = getAddress(lastDropAddress);
        const actualEtaAvl = (this.details.actualEta && this.details.actualEta !== 'NA');
        obj.actualEta = actualEtaAvl ? formatDetailedTime(this.details.actualEta) : '-';
        const etaDiff = actualEtaAvl && getDateDiffInDaysMins(this.details.actualEta, moment());
        obj.etaDetail = this.status &&
            !this.status.excludeEta ? etaDiff && etaDiff.formatted : null;
      }
      if (this.details.latestLocation) {
        obj.lastKnownPlace = this.details.latestLocation &&
            (this.details.latestLocation.city || this.details.latestLocation.address);
        obj.lastKnownTime = formatLastKnownTime(
          this.details.latestLocation.timeStamp,
        );
      }
      return obj;
    },
  },
  methods: {
    formatDate(date) {
      return date ? this.$moment(date).format('DD MMM YYYY') : null;
    },
    formatTime(date) {
      return date ? this.$moment(date).format(this.timeFormat) : null;
    },
    getLocations(arr, details = [], markerValue = null) {
      const locations = [];
      arr && arr.forEach((val, index) => {
        let obj = {};
        if (markerValue) {
          // assuming the index of latlong array and location details array match
          const title = (details && details[0]) &&
              details[index].address.name;
          obj[markerValue] = title;
        }
        obj = Object.assign(obj, {
          lat: val.lat,
          lon: val.lon,
          createdAt: val.created_at,
        });
        locations.push(obj);
      });
      return locations;
    },
  },
};
</script>

